import type { FilterValueType } from '../events'
import { trackAnalyticsEvent } from '../track'

interface TrackFilterChangedParams {
  filterName: string
  filterValue: unknown
  page: string
}

const ENUM_FILTER_VALUE_PATTERN = /^[a-z0-9_-]{1,24}$/i

function normalizeFilterValue(filterValue: unknown): {
  value: string | boolean | null
  type: FilterValueType
} {
  if (filterValue === null) return { value: null, type: 'null' }
  if (filterValue === undefined) return { value: null, type: 'undefined' }

  if (typeof filterValue === 'boolean') {
    return { value: filterValue, type: 'boolean' }
  }

  if (typeof filterValue === 'number') {
    return { value: 'number', type: 'number' }
  }

  if (typeof filterValue === 'string') {
    const normalizedValue = filterValue.trim().toLowerCase()

    if (ENUM_FILTER_VALUE_PATTERN.test(normalizedValue)) {
      return { value: normalizedValue, type: 'enum' }
    }

    return { value: 'string', type: 'string' }
  }

  if (Array.isArray(filterValue)) {
    return { value: 'array', type: 'array' }
  }

  if (typeof filterValue === 'bigint') {
    return { value: 'bigint', type: 'bigint' }
  }

  if (typeof filterValue === 'symbol') {
    return { value: 'symbol', type: 'symbol' }
  }

  if (typeof filterValue === 'function') {
    return { value: 'function', type: 'function' }
  }

  if (typeof filterValue === 'object') {
    return { value: 'object', type: 'object' }
  }

  return { value: 'unknown', type: 'unknown' }
}

export function trackFilterChanged(params: TrackFilterChangedParams) {
  const normalized = normalizeFilterValue(params.filterValue)

  trackAnalyticsEvent('filter_changed', {
    filter_name: params.filterName,
    filter_value: normalized.value,
    filter_value_type: normalized.type,
    page: params.page
  })
}
